var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1239_2265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7547 35.4962C13.7555 35.9876 13.9008 36.4688 14.1734 36.8782L15.5086 38.8852C15.7367 39.2283 16.046 39.5097 16.4091 39.7043C16.7723 39.899 17.1779 40.0008 17.5898 40.0008H22.4109C22.8229 40.0008 23.2285 39.899 23.5916 39.7043C23.9547 39.5097 24.2641 39.2283 24.4922 38.8852L25.8273 36.8782C26.0999 36.4688 26.2455 35.988 26.2461 35.4962L26.2492 32.5001H13.7508L13.7547 35.4962ZM6.25 13.7501C6.25 17.2165 7.53516 20.379 9.65313 22.7954C10.9438 24.268 12.9625 27.3446 13.732 29.9399C13.7352 29.9602 13.7375 29.9805 13.7406 30.0008H26.2594C26.2625 29.9805 26.2648 29.961 26.268 29.9399C27.0375 27.3446 29.0562 24.268 30.3469 22.7954C32.4648 20.379 33.75 17.2165 33.75 13.7501C33.75 6.14147 27.5711 -0.0233709 19.957 6.66077e-05C11.9875 0.0242854 6.25 6.4821 6.25 13.7501ZM20 7.50007C16.5539 7.50007 13.75 10.304 13.75 13.7501C13.75 14.4407 13.1906 15.0001 12.5 15.0001C11.8094 15.0001 11.25 14.4407 11.25 13.7501C11.25 8.92507 15.175 5.00007 20 5.00007C20.6906 5.00007 21.25 5.55944 21.25 6.25007C21.25 6.94069 20.6906 7.50007 20 7.50007Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1239_2265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.70dafca9e60be3f1620b25a597fa9d1b.svg";
export { ForwardRef as ReactComponent };